import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent  implements OnInit {

  constructor(private router: Router,private encryptionService: EncryptionService) { }
  loggedInUserRole:any;
  ngOnInit() {}
  goToDashboard(){
    if (this.loggedInUserRole === 'Super Admin' || this.loggedInUserRole === 'PHI Admin'
      || this.loggedInUserRole === 'PHI Finance & Accounts'
    ){
      this.router.navigate(['/home/companies']);
    }else{
      this.router.navigate(['/home/hrportal/myhome']);
    }
  }

}
